














































































import { defineComponent, reactive, onBeforeMount } from '@vue/composition-api'

import { UserState, MultiUserState } from '@/types/store'
import { UserRole, userTypes } from '@/types/user'
import useVuex from '@/utils/useVuex'

import Layout from '@/components/organisms/common/Layout.vue'
import { UsersTable } from '@/components/organisms/users'

export default defineComponent({
  name: 'Users',
  components: { Layout, UsersTable },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      multiUsers: useVuex<MultiUserState['multiUsers']>(
        context,
        () => store.getters['multiUser/multiUsers'],
      ),
      total: useVuex<MultiUserState['total']>(
        context,
        () => store.getters['multiUser/total'],
      ),
      isMultiUsersLoading: useVuex<MultiUserState['isMultiUsersLoading']>(
        context,
        () => store.getters['multiUser/isMultiUsersLoading'],
      ),
      searchCondition: useVuex<MultiUserState['searchCondition']>(
        context,
        () => store.getters['multiUser/searchCondition'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
    })

    onBeforeMount(() => {
      store.dispatch('multiUser/getMultiUsers', {
        id: state.searchCondition.id,
        code: state.searchCondition.code,
        castId: state.searchCondition.castId,
        castName: state.searchCondition.castName,
        role: state.searchCondition.role,
      })
    })

    const search = () => {
      store.dispatch('multiUser/getMultiUsers', {
        id: state.searchCondition.id,
        code: state.searchCondition.code,
        castId: state.searchCondition.castId,
        castName: state.searchCondition.castName,
        role: state.searchCondition.role,
      })
    }

    const create = async () => {
      await store.dispatch('multiUser/setNewMultiUser')
      context.root.$router.push('/user-edit').catch(() => {
        /*2連打した際のerrorを無視*/
      })
    }

    return { state, search, UserRole, create, userTypes }
  },
})
